<template>
  <div class="content">
    <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(() => {})" @change="getAddressInMapCompar(null)">
          <ModalDomicilio :currentDomicilio="currentDomicilio" @submit.prevent />
        </form>
      </ValidationObserver>
    <DrawGoogleMap :lat="currentDomicilio.lat" :lng="currentDomicilio.lng" style="width: 300px" />
  </div>
</template>

<script>
import DrawGoogleMap from "@/views/clients/comparecientes/DrawGoogleMap.vue";
import ModalDomicilio from "@/views/clients/comparecientes/ModalDomicilio.vue";

import config from "@/config";
import { getGoogleMapUrl } from "@/utils/google-maps-utils";

export default {
  name: "ExampleComponent",

  components: {
    DrawGoogleMap,
    ModalDomicilio,
  },

  setup() {
    getGoogleMapUrl();
  },

  computed: {},

  watch: {},

  mounted() {},

  data() {
    return {
      currentDomicilio: {
        calle: null,
        num_exterior: null,
        colonia: null,
        delegacion_municipio: null,
        codigo_postal: null,
        entidad: null,
        lat: "19.419",
        lng: "-99.163",
      },
      env: process.env.NODE_ENV,
      conf: { ...config },
      query: Object.assign({}, this.$route),
    };
  },

  methods: {
    async getAddressInMapCompar() {
      const address = `${this.currentDomicilio.calle},${this.currentDomicilio.num_exterior},${this.currentDomicilio.colonia},
          ${this.currentDomicilio.delegacion_municipio},${this.currentDomicilio.codigo_postal},${this.currentDomicilio.entidad}`;
      const mapUrl = await getGoogleMapUrl(address);
      this.currentDomicilio.lat = mapUrl?.lat;
      this.currentDomicilio.lng = mapUrl?.lng;
    },
  },
};
</script>
